module.exports = __webpack_public_path__ + "apple-icon-120x120.png?d4364509d210c476ed9d156ae2532cee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple-icon-120x120.png
// module id = 128
// module chunks = 0